export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://lugoda.co.tz/be-tomcat/TransportERPBE-1.0.0',
  TIMEOUT: 30000,
  TOKEN_KEY: 'transport_erp_token',
  USER_KEY: 'transport_erp_user',
};

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
  },
  PROFILE: {
    PASSWORD: '/api/profile/password',
  },
  USERS: {
    BASE: '/api/admin/users',
    BY_ID: (id: number) => `/api/admin/users/${id}`,
  },
  VEHICLES: {
    BASE: '/api/fleet/vehicles',
    ACTIVE: '/api/fleet/vehicles/active',
    BY_ID: (id: number) => `/api/fleet/vehicles/${id}`,
  },
  DRIVERS: {
    BASE: '/api/fleet/drivers',
    ACTIVE: '/api/fleet/drivers/active',
    BY_ID: (id: number) => `/api/fleet/drivers/${id}`,
  },
  ROUTES: {
    BASE: '/api/fleet/routes',
    ACTIVE: '/api/fleet/routes/active',
    BY_ID: (id: number) => `/api/fleet/routes/${id}`,
  },
  TRIPS: {
    BASE: '/api/trips',
    BY_ID: (id: number) => `/api/trips/${id}`,
    BY_DRIVER: (driverId: number) => `/api/trips/driver/${driverId}`,
    START: (id: number) => `/api/trips/${id}/start`,
    COMPLETE: (id: number) => `/api/trips/${id}/complete`,
    UPDATE_AMOUNT: (id: number) => `/api/trips/${id}/amount`,
    BY_STATUS: (status: string) => `/api/trips/status/${status}`,
    DATE_RANGE: '/api/trips/date-range',
  },
  FUEL: {
    BASE: '/api/fuel',
    BY_TRIP: (tripId: number) => `/api/fuel/trip/${tripId}`,
    FLAGGED: '/api/fuel/flagged',
  },
  ALLOWANCES: {
    BASE: '/api/finance/allowances',
    BY_TRIP: (tripId: number) => `/api/finance/allowances/trip/${tripId}`,
    BY_STATUS: (status: string) => `/api/finance/allowances/status/${status}`,
    APPROVE: (id: number) => `/api/finance/allowances/${id}/approve`,
    REJECT: (id: number) => `/api/finance/allowances/${id}/reject`,
  },
  INVOICES: {
    BASE: '/api/finance/invoices',
    BY_ID: (id: number) => `/api/finance/invoices/${id}`,
    ISSUE: (id: number) => `/api/finance/invoices/${id}/issue`,
    DATE_RANGE: '/api/finance/invoices/date-range',
  },
  PROFORMA_INVOICES: {
    BASE: '/api/finance/proforma-invoices',
    BY_ID: (id: number) => `/api/finance/proforma-invoices/${id}`,
    BY_STATUS: (status: string) => `/api/finance/proforma-invoices/status/${status}`,
    ISSUE: (id: number) => `/api/finance/proforma-invoices/${id}/issue`,
    DATE_RANGE: '/api/finance/proforma-invoices/date-range',
  },
  PAYMENTS: {
    BASE: '/api/finance/payments',
    BY_ID: (id: number) => `/api/finance/payments/${id}`,
    BY_INVOICE: (invoiceId: number) => `/api/finance/payments/invoice/${invoiceId}`,
    VERIFY: (id: number) => `/api/finance/payments/${id}/verify`,
    CANCEL: (id: number) => `/api/finance/payments/${id}/cancel`,
    DATE_RANGE: '/api/finance/payments/date-range',
  },
  FINANCE_REPORTS: {
    TRIP: (tripId: number) => `/api/finance/reports/trip/${tripId}`,
    TRIPS: '/api/finance/reports/trips',
    MONTHLY: '/api/finance/reports/monthly',
    YEARLY: '/api/finance/reports/yearly',
    SUMMARY: '/api/finance/reports/summary',
  },
  VEHICLE_ROI: {
    BY_VEHICLE: (vehicleId: number) => `/api/vehicles/roi/${vehicleId}`,
    SUMMARY: (vehicleId: number) => `/api/vehicles/roi/${vehicleId}/summary`,
    FLEET_SUMMARY: '/api/vehicles/roi/all/summary',
  },
  VEHICLE_MAINTENANCE: {
    BASE: '/api/vehicles/maintenance',
    BY_ID: (id: number) => `/api/vehicles/maintenance/${id}`,
    BY_VEHICLE: (vehicleId: number) => `/api/vehicles/maintenance/vehicle/${vehicleId}`,
    DATE_RANGE: '/api/vehicles/maintenance/date-range',
  },
  VEHICLE_EXPENSES: {
    BASE: '/api/vehicles/expenses',
    BY_ID: (id: number) => `/api/vehicles/expenses/${id}`,
    BY_VEHICLE: (vehicleId: number) => `/api/vehicles/expenses/vehicle/${vehicleId}`,
    BY_TRIP: (tripId: number) => `/api/vehicles/expenses/trip/${tripId}`,
    APPROVE: (id: number) => `/api/vehicles/expenses/${id}/approve`,
    REJECT: (id: number) => `/api/vehicles/expenses/${id}/reject`,
    PENDING: '/api/vehicles/expenses/pending',
  },
  CONTRACTS: {
    BASE: '/api/contracts',
    BY_ID: (id: number) => `/api/contracts/${id}`,
    BY_STATUS: (status: string) => `/api/contracts/status/${status}`,
    APPROVE: (id: number) => `/api/contracts/${id}/approve`,
    TRIPS: (id: number) => `/api/contracts/${id}/trips`,
    INVOICES: (id: number) => `/api/contracts/${id}/invoices`,
    PROGRESS: (id: number) => `/api/contracts/${id}/progress`,
    PROFITABILITY: (id: number) => `/api/contracts/${id}/profitability`,
    SUMMARY: '/api/contracts/summary',
  },
  INVOICE_LINE_ITEMS: {
    BY_INVOICE: (invoiceId: number) => `/api/invoices/${invoiceId}/line-items`,
    BY_TRIP: (tripId: number) => `/api/trips/${tripId}/line-items`,
  },
  EMPLOYEES: {
    BASE: '/api/employees',
    ACTIVE: '/api/employees/active',
    BY_ID: (id: number) => `/api/employees/${id}`,
  },
  PAYROLL: {
    BASE: '/api/payroll',
    BY_ID: (id: number) => `/api/payroll/${id}`,
    BY_EMPLOYEE: (employeeId: number) => `/api/payroll/employee/${employeeId}`,
    BY_PERIOD: (year: number, month: number) => `/api/payroll/period/${year}/${month}`,
    BY_YEAR: (year: number) => `/api/payroll/year/${year}`,
    SUBMIT: (id: number) => `/api/payroll/${id}/submit`,
    APPROVE: (id: number) => `/api/payroll/${id}/approve`,
    PAY: (id: number) => `/api/payroll/${id}/pay`,
  },
  TRIP_ALLOWANCES: {
    BY_TRIP: (tripId: number) => `/api/trips/${tripId}/allowances`,
    BY_ID: (tripId: number, allowanceId: number) => `/api/trips/${tripId}/allowances/${allowanceId}`,
  },
  TRIP_EXPENSES: {
    BY_TRIP: (tripId: number) => `/api/trips/${tripId}/expenses`,
    BY_ID: (tripId: number, expenseId: number) => `/api/trips/${tripId}/expenses/${expenseId}`,
  },
  TRIP_FINANCE: {
    SUMMARY: (tripId: number) => `/api/trips/${tripId}/financial-summary`,
  },
};
